import { render, staticRenderFns } from "./AudioWidget.vue?vue&type=template&id=3f2ada1e&scoped=true&"
import script from "./AudioWidget.vue?vue&type=script&lang=js&"
export * from "./AudioWidget.vue?vue&type=script&lang=js&"
import style0 from "./AudioWidget.vue?vue&type=style&index=0&id=3f2ada1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ada1e",
  null
  
)

export default component.exports